// © Microsoft Corporation. All rights reserved.
/**
 * Enum for different browser types
 * @enum
 */
export var BrowserType;
(function (BrowserType) {
    BrowserType["EdgeChromium"] = "edgeChromium";
})(BrowserType || (BrowserType = {}));
//# sourceMappingURL=BrowserTypes.js.map